import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { BASE_PATH as CORRELATION_MATRIX_BASE_PATH } from '@blk/portfolio-security-server/analytics/correlation';
import { BASE_PATH as MODEL_ANALYTICS_BASE_PATH, ModelAnalyticsApiModule } from '@blk/portfolio-security-server/analytics/model';
import { BASE_PATH as PORTFOLIO_ANALYTICS_BASE_PATH, PortfolioAnalyticsApiModule } from '@blk/portfolio-security-server/analytics/portfolio-analytics';
import { AssetApiModule, BASE_PATH as ASSET_BASE_PATH } from '@blk/portfolio-security-server/asset';
import { BASE_PATH as MODELS_BASE_PATH, ModelsApiModule } from '@blk/portfolio-security-server/models';

import { PasApiService } from './services';

export function getAssetBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('apigee-path')}/api/wealth/distribution/asset/v1`;
}

export function getAnalyticsBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('apigee-path')}/api/wealth/distribution/analytics/v1`;
}

export function getModelsBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('apigee-path')}/api/wealth/distribution/models/v1`;
}

@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule, AssetApiModule, PortfolioAnalyticsApiModule, ModelsApiModule, ModelAnalyticsApiModule],
	providers: [
		{
			provide: ASSET_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getAssetBasePath
		},
		{
			provide: PORTFOLIO_ANALYTICS_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getAnalyticsBasePath
		},
		{
			provide: MODELS_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getModelsBasePath
		},
		{
			provide: MODEL_ANALYTICS_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getAnalyticsBasePath
		},
		{
			provide: CORRELATION_MATRIX_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getAnalyticsBasePath
		},
		PasApiService
	]
})
export class PasModule { }
